var DistanceHelper = /** @class */ (function () {
    function DistanceHelper() {
    }
    DistanceHelper.distanceBetweenTwoPoints = function (firstCoordinates, secondCoordinates) {
        var earth_radius = 6371e3; // 6371 km in meters
        var firstLatRadians = this.degreesToRadians(firstCoordinates.latitude);
        var secondLatRadians = this.degreesToRadians(secondCoordinates.latitude);
        var differenceBetweenLatsRadians = this.degreesToRadians(secondCoordinates.latitude - firstCoordinates.latitude);
        var differenceBetweenLongsRadians = this.degreesToRadians(secondCoordinates.longitude - firstCoordinates.longitude);
        var a = Math.sin(differenceBetweenLatsRadians / 2) * Math.sin(differenceBetweenLatsRadians / 2) +
            Math.cos(firstLatRadians) * Math.cos(secondLatRadians) *
                Math.sin(differenceBetweenLongsRadians / 2) * Math.sin(differenceBetweenLongsRadians / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earth_radius * c;
    };
    DistanceHelper.degreesToRadians = function (degrees) {
        return degrees * (Math.PI / 180);
    };
    return DistanceHelper;
}());
export default DistanceHelper;
